<template>
    <div class="mobile-bottom-nav" >
        <router-link
            :class="{ selected: isOnSportsPage }"
            :to="routes.sport"
            class="mobile-bottom-nav__item"
        >
            <i class="icon icon-sport-5"/>
            <span>{{ $t('sport') | capitalize }}</span>
        </router-link>
        <router-link
            :class="{ selected: isOnSportLivePage }"
            :to="routes.live"
            class="mobile-bottom-nav__item"
        >
            <i class="icon icon-live_indicator"/>
            <span>{{ $t('live') | capitalize }}</span>
        </router-link>
        <router-link
            :class="{ selected: isOnSpecialsPage }"
            :to="routes.specials"
            class="mobile-bottom-nav__item"
        >
            <i class="icon icon-special"/>
            <span>{{ $t('specials') | capitalize }}</span>
        </router-link>
        <router-link
            :class="{ selected: isOnCasinoLive }"
            :to="routes.casinoLive"
            class="mobile-bottom-nav__item"
        >
            <i class="icon icon-casino_live"/>
            <span>{{ $t('casino') | capitalize }}</span>
        </router-link>
        <router-link
            v-if="!!user"
            :class="{ selected: isOnTicketsPage }"
            :to="routes.myTickets"
            class="mobile-bottom-nav__item"
        >
            <i class="icon icon-ticket_2"/>
            <span>{{ $t('my tickets') | capitalize }}</span>
        </router-link>
        <router-link
            v-else
            :class="{ selected: isOnShopsPage }"
            :to="routes.shops"
            class="mobile-bottom-nav__item"
        >
            <i class="icon icon-shop"/>
            <span>{{ $t('shops') | capitalize }}</span>
        </router-link>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { routeNames } from '@app/router';
    import { liveTimeFilterSlug, todayTimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';

    export default {
        created() {
            this.routes = {
                sport: {
                    name: routeNames.sportOffer,
                    params: {
                        timeFilter: todayTimeFilterSlug,
                    },
                },
                live: {
                    name: routeNames.sportOffer,
                    params: {
                        timeFilter: liveTimeFilterSlug,
                    },
                },
                specials: { name: routeNames.special },
                casinoLive: { name: routeNames.casinoLive },
                myTickets: { name: routeNames.tickets },
                shops: { name: routeNames.shops },
            };
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
            ...mapGetters('navigation', [
                'isOnSportLivePage',
                'isOnSportsPage',
            ]),
            isOnSpecialsPage() {
                return this.$route.name === this.routes.specials.name;
            },
            isOnCasinoLive() {
                return this.$route.name === this.routes.casinoLive.name;
            },
            isOnTicketsPage() {
                return this.$route.name === this.routes.myTickets.name;
            },
            isOnShopsPage() {
                return this.$route.name === this.routes.shops.name;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/mobile/components/SportNav.vue